<!-- 

    增加販售一抽券頁面 提供給廠商購買
    廠商購買後可以發給客人，需綁定廠商的商品使用

    新頁面 ( 購買一抽券 )：

    一次買 100 張 95 折

 -->

<template>
  <v-container fluid>
    <!-- 輸入框和新增按鈕 -->
    <v-layout class="align-center">
      <span
        >一抽券 400
        <span class="text-gray" style="font-size: 14px;">/ 張</span></span
      >

      <span class="mx-4">*</span>
      <!-- <v-text-field
        v-model="newQty"
        class="ml-3"
        style="max-width: 80px;"
        label="數量"
        type="number"
        min="0"
      ></v-text-field> -->

      <v-autocomplete
        v-model="newQty"
        :items="autocompleteItems"
        label="數量"
        class="ml-3"
        style="max-width: 80px;"
      ></v-autocomplete>

      <div v-if="discount < 1">
        <span class="mx-4">*</span>

        <span style=" color: #7BD13E;">{{ discount }}</span>
      </div>
      <span class="mx-4">=</span>
      <span class="mr-4"
        ><span class="text-gray">總額</span> $ {{ newSum }}</span
      >

      <v-btn
        color="blue lighten-2"
        class="ml-3"
        @click="checkBuy()"
        :disabled="newQty <= 0 || newSum == ''"
        >購買</v-btn
      >
    </v-layout>

    <!-- 優惠提示 -->
    <p style=" color: #7BD13E; font-weight: 500;">一次購買 100 張一抽券，享受 95 折的優惠 🥳</p>

    <v-divider style="margin-bottom: 20px;"></v-divider>

    <!-- 搜尋 -->
    <v-layout class="align-center">
      <v-menu
        v-model="startDateMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="startDate"
            label="起始日"
            readonly
            v-bind="attrs"
            v-on="on"
            style="margin-right: 20px"
          ></v-text-field>
        </template>
        <v-date-picker v-model="startDate" no-title></v-date-picker>
      </v-menu>

      <v-menu
        v-model="endDateMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="endDate"
            label="結束日"
            readonly
            v-bind="attrs"
            v-on="on"
            style="margin-right: 20px"
          ></v-text-field>
        </template>
        <v-date-picker v-model="endDate" no-title></v-date-picker>
      </v-menu>

      <v-btn color="green lighten-2" class="ml-3" @click="loadData">搜尋</v-btn>
    </v-layout>

    <!-- 紀錄 -->
    <v-data-table
      :headers="headers"
      :items="giftList"
      :items-per-page="itemsPerPage"
      hide-default-footer
    >
      <template v-slot:item="{ item }">
        <tr>
          <!-- <td>
            {{ item.targetId }}
          </td>
          <td>
            {{ getGiftOptionText(item.type) }}
          </td> -->
          <!-- <td v-if="vendorList && vendorList.length > 0">
            {{ item.type === 1 ? getVendorName(item.vendorId) : "" }}
          </td> -->
          <td>
            {{ item.count }}
          </td>
          <td>
            {{ item.createdDate }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import common from "@/mixins/common";
import { mapActions } from "vuex";
export default {
  name: "label",
  mixins: [common],
  data() {
    return {
      newEmail: "",
      newType: 0,
      newQty: 0,
      autocompleteItems: [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        59,
        60,
        61,
        62,
        63,
        64,
        65,
        66,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        75,
        76,
        77,
        78,
        79,
        80,
        81,
        82,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        91,
        92,
        93,
        94,
        95,
        96,
        97,
        98,
        99,
        100,
      ],
      newVendor: "",
      // giftOptions: [
      //   { text: "刮刮卡", value: 1 },
      //   { text: "一抽券", value: 2 },
      //   { text: "代幣", value: 4 },
      //   { text: "紅利", value: 5 },
      // ],
      startDate: null,
      endDate: null,
      startDateMenu: false,
      endDateMenu: false,
      itemsPerPage: 100,
      giftList: [],
      vendorList: [],
      buyList: [],
      headers: [
        // { text: "收禮人 id", value: "text" },
        // { text: "贈送品項", value: "text" },
        // { text: "廠商", value: "text" },
        { text: "購買數量", value: "text" },
        { text: "時間", value: "text" },
      ],
    };
  },
  watch: {
    // newType() {
    //   // 當 newType 的值變動時，將 newVendor 設置為空字串
    //   // 防呆：避免其他品項掛到廠商
    //   this.newVendor = "";
    // },
  },
  methods: {
    ...mapActions(["getUserGiftList", "saveUserGift", "getVendorList"]),
    // 載入所有贈送紀錄資料, 預設取當月份資料

    async checkBuy() {
      // console.log('刪除待辦事項:', item);
      this.showAlert({
        title: "提示",
        content: `是否確定要花費 $ ${this.newSum} 購買 ${this.newQty} 張一抽券 ?`,
        confirmEvent: async () => {
          this.hideAlert();
          await this.saveBuy();
          // await this.deleteTagInfo({ tagId: item });
          // this.loadData();
        },
      });
    },
    // 購買 api
    async saveBuy() {
      let data = {
        qty: Number(this.newQty),
        sum: Number(this.newSum),
      };
      console.log(`saveBuy ${JSON.stringify(data)}`);
    },

    /* * 以下是舊的 */
    async loadData() {
      let data = {
        startDate: this.startDate,
        endDate: this.endDate,
        pageIndex: 1,
        limit: 100,
      };
      try {
        this.loading = true;
        const res = await this.getUserGiftList(data);
        if (res.data.statusCode === 0) {
          // console.log(`getTagList ${JSON.stringify(res.data.data)}`);
          this.giftList = res.data.data.list;
          console.log(`giftList ${JSON.stringify(this.giftList)}`);
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log(`getUserGiftList error`, e.stack);
      }
    },
    // 載入廠商資料
    async loadVendorList() {
      try {
        this.loading = true;
        const res = await this.getVendorList();
        console.log(`loadVendorList ${JSON.stringify(res.data)}`);
        if (res.data.statusCode === 0) {
          // console.log(`getTagList ${JSON.stringify(res.data.data)}`);
          this.vendorList = res.data.data;
          console.log(`loadVendorList ${JSON.stringify(this.vendorList)}`);
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log(`loadVendorList error`, e.stack);
      }
    },
    // 新增贈送
    async add() {
      // if (this.newTag.trim() === "") return;

      // 收集數據並發送到後端
      const data = {
        targetId: this.newEmail,
        type: this.newType,
        count: Number(this.newQty),
        vendorId: this.newVendor,
      };

      // 檢查每個欄位是否有輸入
      if (data.targetId.trim() === "" || data.type === "") {
        // 如果有任何一個欄位為空，則不發送數據
        // 您可以在這裡添加提示用戶的代碼，例如：
        alert("所有欄位都要輸入才能發送!");
        return;
      }

      // 檢查數量是否為數值
      if (isNaN(data.count) || data.count <= 0) {
        alert("數量必須為數值且不可等於零!");
        return;
      }

      // 檢查刮刮樂一定要選廠商
      if (data.type === 1 && data.vendorId === "") {
        alert("刮刮樂必須選擇廠商!");
        return;
      }

      // 假設您有一個方法來處理發送數據
      console.log(`data ${JSON.stringify(data)}`);

      try {
        this.loading = true;
        const res = await this.saveUserGift(data);
        if (res.data.statusCode === 0) {
          console.log(`addInfo ${JSON.stringify(res.data)}`);
          this.newEmail = "";
          this.newType = 0;
          this.newQty = 0;
          this.newVendor = "";
          this.loadData();
          this.loadVendorList();
        } else {
          alert("發生錯誤，請稍後再試或聯繫客服!");
        }
      } catch (e) {
        this.loading = false;
        console.log(`saveTagInfo error`, e.stack);
        alert("發生錯誤，請稍後再試或聯繫客服!");
      }
    },
    // 測試搜尋日期
    // search() {
    //   // 在這裡處理搜尋邏輯
    //   // 例如，您可以使用 startDate 和 endDate 來篩選數據
    //   console.log(`搜尋起始日: ${this.startDate}, 結束日: ${this.endDate}`);
    // },
    // 獲取當月的第一天和最後一天
    getCurrentMonthDates() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth();

      // 獲取當月的第一天
      const firstDay = new Date(year, month, 1);
      // 獲取當月的最後一天
      const lastDay = new Date(year, month + 1, 0);

      // 將日期格式化為 yyyy-mm-dd 格式
      const formatDate = (date) => {
        const d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();

        return [year, month.padStart(2, "0"), day.padStart(2, "0")].join("-");
      };

      return {
        startDate: formatDate(firstDay),
        endDate: formatDate(lastDay),
      };
    },
    // 獲取當前選擇廠商
    handleVendorChange(selectedVendorId) {
      this.newVendor = selectedVendorId;
      console.log(`Selected vendor ID: ${this.newVendor}`);
    },
    // 轉換品項名稱
    getGiftOptionText(value) {
      // 遍歷 giftOptions 數組來找到對應的物件
      const option = this.giftOptions.find((option) => option.value === value);
      // 如果找到了對應的物件，返回其 text 屬性，否則返回空字串
      return option ? option.text : "";
    },
    // 轉換廠商名稱
    getVendorName(vendorId) {
      // 遍歷 vendorList 數組來找到對應的物件
      const vendor = this.vendorList.find(
        (vendor) => vendor.vendorId === vendorId
      );
      // 如果找到了對應的物件，返回其 name 屬性，否則返回空字串
      return vendor ? vendor.name : "";
    },
  },
  //  頁面載入時加載資料
  created() {
    const { startDate, endDate } = this.getCurrentMonthDates();
    this.startDate = startDate;
    this.endDate = endDate;
    this.loadVendorList();
    this.loadData();
  },
  computed: {
    discount() {
      return this.newQty >= 100 ? 0.95 : 1;
    },
    newSum() {
      return 400 * this.newQty * this.discount;
    },
  },
};
</script>

<style scoped>
.text-gray {
  color: #878787;
}
</style>
